import React, { useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { isAfter } from 'date-fns';
import clsx from 'clsx';
import { CountdownTimer } from '../CountdownTimer';
import { Icon, IconsTypes } from '../../components/Icon';
import { Button, ButtonVariant } from '../../components/Button';
import s from './HeaderNotification.module.scss';

export interface HeaderNotificationProps {
  isTimer?: boolean;
  textButton?: string;
  title?: string;
  subTitle?: string;
}

export function HeaderNotification({ isTimer, textButton, subTitle, title }: HeaderNotificationProps) {
  const dateEnd = useRef(new Date('2025-09-11T00:01:00.000+03:00'));

  const showBanner = useMemo(() => {
    return !isAfter(new Date(), dateEnd.current);
  }, []);
  return (
    <>
      {isTimer && (
        <>
          {showBanner && (
            <div className={s.HeaderNotification}>
              <div className={s.HeaderNotification__text}>
                <h3>Урегулируйте свой правовой статус до 10&nbsp;сентября 2025&nbsp;года</h3>
              </div>
              <div className={s.Notification__timerWrap}>
                <CountdownTimer dateEnd={dateEnd.current} className={s.Notification__timer} />
                <Link to={'https://mc.mos.ru/info/legalization'}>
                  <Icon icon={IconsTypes.ARROW_LINK} />
                  <span>Перейти</span>
                </Link>
              </div>
            </div>
          )}
        </>
      )}

      {!isTimer && (
        <div className={clsx(s.HeaderNotification, s.HeaderNotification_default)}>
          <div className={s.HeaderNotification__title}>
            <h3>{title}</h3>
            <p>{subTitle}</p>
          </div>
          <Button
            Component={'a'}
            href={'https://mc.mos.ru/info/amina'}
            variant={ButtonVariant.PrimaryGreen}
            className={s.InfoBanner__accept}
            iconRight={IconsTypes.ARROW_LINK}>
            {textButton}
          </Button>
        </div>
      )}
    </>
  );
}
